import { Injectable } from '@angular/core';
import { Http, QueryBus, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { OrderRepositoryBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root' })
@Wrapper(OrderRepositoryBase)
export class OrderRepository {
    public constructor(
        http: Http,
        weaver: Weaver,
        queryBus: QueryBus
    ) { }
}
